<template>
  <main class="h-full w-full">
    <EditorDeck :deck-id="deckId" :init-slide="initSlide" :uuid="uuid" />
  </main>
</template>

<script lang="ts" setup>
definePageMeta({ layout: 'isolated-page' })

const route = useRoute()

if (!+route.params.id) {
  const res = /(\d+).*/.exec(`${route.params.id}`)
  if (res?.[1]) {
    navigateTo({ name: 'editor-decks-id', params: { id: res[1] }, replace: true })
  }
}

const deckId = `${route.params.id}`
const initSlide = route.query.slide ? `${route.query.slide}` : ''
const uuid = `${route.query.auth}`
</script>
